import { render, staticRenderFns } from "./DvNavDropdown.vue?vue&type=template&id=9136f690&scoped=true"
import script from "./DvNavDropdown.vue?vue&type=script&lang=js"
export * from "./DvNavDropdown.vue?vue&type=script&lang=js"
import style0 from "./DvNavDropdown.vue?vue&type=style&index=0&id=9136f690&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9136f690",
  null
  
)

export default component.exports